import { RecordList } from "./RecordList";
import { api } from "../lib/api";
import { PageShell } from "./PageShell";
import { ConsoleIcon } from "./ConsoleIcon";

const go = page => { window.location.hash = `/app/${page}`; };


export function Users() {
  return <RecordList title="Users and access" subtitle="Accounts visible within your workspace." load={api.listUsers}
    description="Owners and admins can view their workspace directory. Other roles see their own account. Invitations and role editing are not available here."
    empty="No accounts returned." columns={[
      { label: "Name", render: row => row.name },
      { label: "Email", render: row => row.email },
      { label: "Role", render: row => row.role },
      { label: "Status", render: row => row.is_active ? "Active" : "Disabled" },
      { label: "Knowledge bases", render: row => row.kb_count },
    ]} />;
}

export function Billing() {
  return <PageShell title="Billing" subtitle="Subscription and payment information." className="account-production">
    <div className="int-notice" role="status"><strong>Billing is not connected</strong><span>This build has no billing service. A subscription, payment status, or plan entitlement cannot be verified here.</span></div>
    <section className="account-summary"><header><ConsoleIcon name="billing" size={24}/><h2>No verified billing record</h2></header><p>Plan changes, checkout, invoices, and payment methods are unavailable in this console. No payment or subscription change can be made from this page.</p></section>
    <section className="account-next"><div><h2>Looking for usage?</h2><p>Analytics shows recorded requests and token usage. Those records are not an invoice, billing-period total, or plan allowance.</p></div><button className="btn btn-outline" onClick={() => go("analytics")}>View workspace usage</button></section>
  </PageShell>;
}
